import { Notification } from 'element-ui'
import store from 'store'
import router from 'router'

const notifyError = (message) => {
  return Notification({
    title: '错误',
    message: message,
    duration: 4000,
    type: 'error'
  })
}

const requestError = (res) => {
  notifyError(res.data.message)
}

const loginError = () => {
  store.dispatch('logout')
  router.replace({ name: 'login' })
}

const authError = () => {
  notifyError('无权限, 请联系管理员！')
}

function uniqueError () {
  notifyError('已存在')
}

function serverError () {
  notifyError('服务器错误')
}

function serverOff () {
  notifyError('服务器忙！请稍后重试')
}

const handleMethods = new Map([
  [400, requestError], // 客户端引起的异常
  [401, loginError], // 没有携带有效的身份验证
  [403, authError],
  [409, uniqueError], // 唯一性验证冲突
  [422, requestError], // 请求参数字段验证不通过
  [500, serverError], // 服务器内部错误
  [502, serverOff]
])

// 请求
export const reqSuccess = (config) => {
  config.headers['Authorization'] = `Bearer ${store.state.app.token}`

  return config
}

export const reqError = (error) => {
  return Promise.reject(error)
}

// 响应
export const resSuccess = (res) => {
  return res
}

export const resError = (error) => {
  const res = error.response
  if (res) {
    if (handleMethods.has(res.status)) {
      const handle = handleMethods.get(res.status)
      handle(res)
    }
  } else {
    notifyError(error.message)
  }
  return Promise.reject(error)
}
